import { RiCheckLine } from '@remixicon/react';
import React, { useState } from 'react';
import styles from './ContentActions.module.css';
import { Action, ActionNames } from '../../../types/Content';

export type ContentActionsProps = {
  actions: Action[];
  handleActionClick: (actionName: string, rowIndex?: number | null) => void;
  actionsRef: React.Ref<HTMLDivElement>;
  isSecondaryOptions?: boolean;
  classes?: string;
  rowIndex?: number | null;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  hasPrimaryActions?: boolean;
};

const ContentActions: React.FC<ContentActionsProps> = ({
  actions = [],
  handleActionClick,
  actionsRef,
  isSecondaryOptions = false,
  classes = '',
  rowIndex = null,
  onMouseEnter,
  onMouseLeave,
  hasPrimaryActions = true,
}) => {
  const [isCopied, setIsCopied] = useState(false);
  const handleActionClickEvent = (actionName: string): void => {
    if (actionName === ActionNames.COPY_TEXT) {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 4000);
    }
    handleActionClick(actionName, rowIndex);
  };
  return (
    <div
      className={`${styles.content_actions_container} ${classes}`}
      ref={actionsRef}
      role='menu'
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={
        isSecondaryOptions
          ? {
              left: hasPrimaryActions
                ? 'calc(100% + 110px)'
                : 'calc(100% + 60px)',
              zIndex: 100,
            }
          : {}
      }
    >
      {actions.map((action: Action, index: number) => {
        return (
          <React.Fragment key={action.name}>
            <div
              className={styles.content_action}
              onClick={() => handleActionClickEvent(action.name)}
              onKeyDown={() => handleActionClickEvent(action.name)}
              role='button'
              tabIndex={0}
              title={action.label}
            >
              {action.name === ActionNames.COPY_TEXT && isCopied ? (
                <RiCheckLine />
              ) : (
                action.icon
              )}
            </div>
            {index < actions.length - 1 && <div className={styles.separator} />}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ContentActions;
